import { render } from "./Admin.vue?vue&type=template&id=b112fd16&scoped=true&bindings={\"getRouteLabel\":\"options\"}"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=b112fd16&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b112fd16"

export default script